// src/api/profileApi.js
import AuthService from "./axiosInstance";
import endpoints from "./endpoints";

const profileApi = {
  async getProfile() {
    const res = await AuthService.get(endpoints.PROFILE_ME);
    return res.data;
  },

  async updateProfile(data) {
    const res = await AuthService.patch(endpoints.PROFILE_ME, data);
    return res.data;
  },

  async deleteAccount() {
    const res = await AuthService.delete(endpoints.ACCOUNT_DELETE);
    return res.data;
  },
};

export default profileApi;
